import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { createContext, useContext, ReactNode } from 'react'
import { ExampleBrand } from 'types'

export interface BrandKitContextValue {
  url: string
  setUrl: (url: string) => void
  isDirty: boolean
  setIsDirty: (isDirty: boolean) => void
  isValid: boolean
  errorMessage?: ReactNode
  isBlank: boolean
  inputProps: Omit<React.InputHTMLAttributes<HTMLInputElement>, 'name'> & { name: string }
  onGenerateFromWebsite: () => void | Promise<void>
  onGenerateFromExampleBrand: (brand: ExampleBrand) => void | Promise<void>
  onGenerateFromIntegration: (integration: {
    id: number
    name: string
    provider: ExternalIntegrationEnum
  }) => void | Promise<void>
}

export const BrandKitContext = createContext<BrandKitContextValue | null>(null)

export function useBrandKitContext(): BrandKitContextValue {
  const ctx = useContext(BrandKitContext)
  if (!ctx) {
    throw new Error('useBrandKitContext must be used within a BrandKitContext.Provider')
  }
  return ctx
}
